/*
 * LEGACY
*/
document.addEventListener('DOMContentLoaded', function() {
    const DEFAULT_SUB = 'Subscribe & save';
    // To stop duplicate when clicking subscription more than once
    let processingSubscription = false;

    const otpEl = `<span class="slidecart-item-purchase-frequency ">One-time purchase</span>`;

    function debounce(func, wait) {
        let timeout;
        return function(...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }

    const renderCart = debounce(async function(dispatchEvent = true) {
        await debouncedRenderCart(dispatchEvent);
    }, 300);

    async function debouncedRenderCart(dispatchEvent = true) {
			var HIDDEN = 'is-hidden';
			var finalCartData;
			return $.ajax({
				type: 'GET',
				url: '/cart.js',
				dataType: 'json',
				success: function(cart) {

					var $recommendations = $('cart-drawer-recommendations');
					var $titleEl = $('cart-drawer .drawer__title');
					var $labelEl = $('cart-drawer .drawer__label');
					var $emptyCart = $('#slidecart-wrapper .empty-cart');
					var $footer = $('.drawer__footer');
					var $shippingBar = $('.slidecart-wrapper free-shipping-bar');
					var $products = $('.slidecart-inner-wrapper');

					var label = $titleEl.data('title');
					var itemLabel = $titleEl.data('label');
					var count = cart.item_count;

					// MIXED
					if ( count > 0 ) {
						$emptyCart.addClass(HIDDEN);
						$footer.removeClass(HIDDEN);
						$shippingBar.removeClass(HIDDEN);
						$products.removeClass(HIDDEN);
						if ( count > 1 ) {
							label = `${count} ${itemLabel}s`;
						} else {
							label = `${count} ${itemLabel}`;
						}
					} else {
						$emptyCart.removeClass(HIDDEN);
						$footer.addClass(HIDDEN);
						$shippingBar.addClass(HIDDEN);
						$products.addClass(HIDDEN);

						// FOCAL Element
						if ( $recommendations ) {
							$recommendations.animate({
								left: "+=240"
							}, 300, function() {
								$(this).remove();
							});
						}
					}

					$labelEl.text(label);
					clearCartDrawer();
					const obscuredCartData = obscureCartData(cart);
					updateQuantityElements(obscuredCartData);

					// MIXED: Update free shipping bar
                    if ( dispatchEvent) {
                        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                            bubbles: true,
                            detail: {
                                cart
                            }
                        }));
                    }

					// MIXED: Update cart count
					$countEl = $('cart-count.header__cart-count');
					var count = cart.items.filter((item) => item.title.match(/\bbuild\b.*\bbox\b|\bbox\b.*\bbuild\b/gi)).length;
					$countEl.html(parseInt(cart.item_count) - parseInt(count));

					$('span.dd-cart-count').html(parseInt(cart.item_count) - parseInt(count));
					if (cart.item_count == 0) {
						jQuery('span.dd-cart-count').hide();
						jQuery('.cart-dd-fs-us').hide();
					} else {
						jQuery('span.dd-cart-count').show();
						jQuery('.cart-dd-fs-us').show();
					}

					$(`[shipping-bar-percent]`).css('max-width', '0%');
					const freeShipText = $(`[slidecart-shipping-bar]`).attr('free-shipping-text');
					const freeShipping = $(`[slidecart-shipping-bar]`).attr('free-shipping-minimum');

                    const totalDisplay = window.RS.helpers.formatMoney(cart.total_price, window.themeVariables.moneyFormat);
					const cartSubtotalInfo = `<h2>SUBTOTAL</h2> ${totalDisplay}`;
					// $(`[cart-subtotal]`).html(cartSubtotalInfo);
					$(`[cart-subtotal]`).attr("cart-subtotal", cart.original_total_price);
					$('[shipping-notice]').each(function() {
							var text = $(this).text();
							if (text.includes('{{ price }}')) {
									text = text.replace('{{ price }}', `$${freeShipping}`);
									$(this).text(text);
							}
					});
					var amountToShipping = (parseInt(freeShipping)-parseFloat(cart.items_subtotal_price/100).toFixed(2)).toFixed(2);
					if (amountToShipping <= 0 ){
							$(`[shipping-bar-percent]`).css('max-width', '100%');
							$('[shipping-notice]').each(function() {
									var text = $(this).attr('shipping-text');
									if (text.includes('{{ amount }}')) {
											text = `${freeShipText}`;
											$(this).text(text);
									}
							});
							$('.shipping-info-amount-pre-threshold').addClass('hidden');
							$('.shipping-info-amount-post-threshold').removeClass('hidden');
					} else if (parseInt(amountToShipping) == parseInt(freeShipping)) {
							$('[slidecart-product-wrapper]').html('');
							$('[shipping-notice]').each(function() {
									var text = $(this).attr('shipping-text');
									if (text.includes('{{ amount }}')) {
											text = 'Your cart is empty';
											$(this).text(text);
									}
							});
							$('.shipping-info-amount-pre-threshold').removeClass('hidden');
							$('.shipping-info-amount-post-threshold').addClass('hidden');
					} else {
							$('[shipping-notice]').each(function() {
									var text = $(this).attr('shipping-text');
									if (text.includes('{{ amount }}')) {
											text = text.replace('{{ amount }}', `$${amountToShipping}`);
											$(this).text(text);
									}
							});
							$(`[shipping-label]`).html('');
							var maxWidth = (parseFloat(cart.items_subtotal_price/100).toFixed(1)/parseInt(freeShipping))*100;
							$(`[shipping-bar-percent]`).css('max-width', maxWidth+'%');
							$('.shipping-info-amount-pre-threshold').removeClass('hidden');
							$('.shipping-info-amount-post-threshold').addClass('hidden');
					}

					obscuredCartData.forEach((item, index) => {
                            const isFreeGift = item.isFreeGift;
							const productTitle = `<h2>${item.itemTitle}</h2>`;
							const productHandle = item.itemHandle;
							const productId = item.itemID;
							const productImage = `<img src="${item.itemImage}" >`;
                            const originalPriceDisplay = window.RS.helpers.formatMoney(item.itemOriginalPrice, window.themeVariables.moneyFormat);
							const originalPrice = (item.itemOriginalPrice !== '') ? `<strike>${originalPriceDisplay}</strike>` : '';
                            const priceDisplay = window.RS.helpers.formatMoney(item.itemPrice, window.themeVariables.moneyFormat);
							const productPrice = `<p>${originalPrice} <span>${priceDisplay}</span></p>`;
                            const productPriceLabel = `${isFreeGift ? 'Free!' : productPrice}`;
							const productQuantity = item.itemQuantity;
							const productUrl = item.itemUrl;
							const productKey = item.itemKey;
							const productPlanAllocation = item.itemSellingPlanAllocation;
							const productBundleID = item.itemBundleID;
							const isBundleChild = item.isBundleChild;
							const isBundleParent = item.isBundleParent;
							const bundleChildKeys = item.bundleChildKeys;
							const bundleChildQuantities = item.bundleChildQuantities;
							const bundleItemList = item.bundleItemList;
							const bundleParentKey = item.bundleParentKey;
                            const variantTitle = item.variantTitle;
                            const quantityEl = `
                                <div class="slidecart-qty-wrapper" >
                                    <button class="qty-button qty-minus-button js-minus-button" data-minus data-qty-button data-key="${productKey}">-</button>
                                    <input class="cart-qty-input js-cart-qty-input" type="number" pattern="[0-9]*" data-input-key="${productKey}" value="${productQuantity}"/>
                                    <button class="qty-button qty-plus-button js-plus-button" data-plus data-qty-button data-key="${productKey}">+</button>
                                </div>
                            `;
							let productPackSize,
									sellingPlanId,
									planType,
									planIdLoaded = false,
									toggleButtonClass,
									subscribeDropdownClass,
									sellingPlanGroup,
									percentOff,
									sellingPlans,
									productBundleId;
	
							jQuery.getJSON(window.Shopify.routes.root + `products/${productHandle}.js`, (product) => {
                                if (product.selling_plan_groups.length > 0) {
                                    if (product.selling_plan_groups.length > 1) {
                                        sellingPlanGroup = product.selling_plan_groups.find(group => {
                                            return group.app_id === '5859381' && group.name === DEFAULT_SUB;
                                        });
                                        sellingPlans = sellingPlanGroup?.selling_plans;
                                    } else {
                                        sellingPlanGroup = product.selling_plan_groups[0];
                                        sellingPlans = sellingPlanGroup.selling_plans;
                                    }
                                }
							}).done((product) => {
									// Item is a subscription
									if (productPlanAllocation) {
                                        sellingPlanId = item.itemPlanId;
                                        planType = item.itemPlanType;
                                        toggleButtonClass = 'hidden';
                                        subscribeDropdownClass = '';
									}
									// Item is one-time purchase
									else {
                                        if (product.selling_plan_groups.length > 0) {
                                            if (product.selling_plan_groups.length > 1) {
                                                sellingPlanGroup = product.selling_plan_groups.find(group => {
                                                    return group.app_id === '5859381' && group.name === DEFAULT_SUB;
                                                });
                                                sellingPlans = sellingPlanGroup?.selling_plans;
                                            } else {
                                                sellingPlanGroup = product.selling_plan_groups[0];
                                                sellingPlans = sellingPlanGroup.selling_plans;
                                            }
                                            sellingPlanId = sellingPlanGroup.selling_plans[0].id;
                                            toggleButtonClass = '';
                                            subscribeDropdownClass = 'hidden';
                                        } else {
                                                toggleButtonClass = 'hidden';
                                                subscribeDropdownClass = '';
                                        }
                                        planType = 'One-time purchase';
									}
									planIdLoaded = true;
							});
						
							function renderItem() {

									if(planIdLoaded === false){ 
											window.setTimeout(renderItem, 100);
									}
									else {
											let concatSellingPlanOptions = '';
											if (sellingPlans) {
													sellingPlans.forEach(plan => {
															let sellingPlanSelectAttr;
															if (plan.id === sellingPlanId) sellingPlanSelectAttr = 'selected'
															concatSellingPlanOptions =  `
																	${concatSellingPlanOptions} 
																	<option value="${plan.id}" 
																			product_id="${productId}" 
																			qty="${productQuantity}" 
																			key="${productKey}"
																			plan_id="${sellingPlanId}"
																			${sellingPlanSelectAttr}
																	>
																			${plan.name}
																	</option>
															`;
													});
											}
											const concatSubscribeDropdown = sellingPlans ?`
													<select name="selling_plan" class="cart_item_selling_plan ${subscribeDropdownClass}" data-subscribe-select>
															<option value="" 
																	product_id="${productId}" 
																	qty="${productQuantity}" 
																	key="${productKey}"
																	plan_id="${sellingPlanId}"
															>
																	One-Time Purchase 
															</option>
															${concatSellingPlanOptions}
													</select>
											`:`${!isFreeGift ? otpEl : ''}`;
	
											const concatProductInfo = `
													<div class="slidecart-item-wrapper" 
                                                            data-item-selling-plan="${item.itemPlanType}"
															data-slidecart-item="${productId}" 
															data-line="${Number(index + 1)}" 
															data-bundle-child-keys="${bundleChildKeys}" 
															data-bundle-child-quantities="${bundleChildQuantities}" 
															data-bundle-id="${productBundleID}" 
															data-bundle-parent-key="${bundleParentKey}" 
													>
															<div class="slidecart-item-image-wrapper">${productImage}</div>
															<div class="slidecart-item-details-wrapper">
																	<div class="slidecart-item-details-top">
																			<div class="slidecart-item-description-wrapper">
                                                                                <div class="prodTitle">
                                                                                    <div class="prodTitle-wrapper">
                                                                                        <a class="slidecart-item-title" href="${productUrl}">${productTitle}</a>
                                                                                        <div class="slidecart-item-variant-title">${variantTitle}</div>
                                                                                        ${bundleItemList}
                                                                                    </div>
                                                                                    <span class="slidecart-item-price">${productPriceLabel}</span>
                                                                                    <span class="slidecart-item-purchase-frequency ${toggleButtonClass}">${planType}</span>
                                                                                </div>
                                                                                ${concatSubscribeDropdown}
																			</div>
																			<div class="slidecart-item-qty-wrapper">
																				${!isFreeGift ? quantityEl : ''}
																				<button class="removeItem${isFreeGift ? ' free-gift': ''}" data-remove-key="${productKey}">Remove</button>
																			</div>
																	</div>
																	<button class="cart-item-payment-options__button ${toggleButtonClass}"
																			key="${productKey}" 
																			qty="${productQuantity}" 
																			plan_id="${sellingPlanId}"
																			product_id="${productId}" 
																			data-cart-toggle-subscribe 
																	>
																			Subscribe & save (15%)
																	</button>
															</div>
													</div>`;
                                            if(window.location.pathname == '/cart') {
                                                let lineItem = document.querySelector(`.line-item[data-line="${Number(index + 1)}"]`)
                                                if(lineItem) {
                                                    lineItem.setAttribute("data-slidecart-item", productId);
                                                    lineItem.setAttribute("data-line", Number(index + 1));
                                                    lineItem.setAttribute("data-bundle-child-keys", bundleChildKeys);
                                                    lineItem.setAttribute("data-bundle-child-quantities", bundleChildQuantities);
                                                    lineItem.setAttribute("data-bundle-id", productBundleID);
                                                    lineItem.setAttribute("data-bundle-parent-key", bundleParentKey);

                                                    if(document.querySelector(`.line-item[data-line="${Number(index + 1)}"] .line-item__product .line-item__info .product-item-meta__property-list`)) {
                                                        let properties = $(`.line-item[data-line="${Number(index + 1)}"] .line-item__product .line-item__info div.product-item-meta__property-list`);
                                                    }
                                                }
                                            }
											else if(!document.querySelector(`.slidecart-item-wrapper[data-line="${Number(index + 1)}"]`)){
													$(`[slidecart-product-wrapper]`).html($(`[slidecart-product-wrapper]`).html() + concatProductInfo);
											}
									}
							}
							if (isBundleChild) return;
							renderItem();
					});
					finalCartData = obscuredCartData;
				},
				complete: () => {
					//document.dispatchEvent(new CustomEvent('cart:render-complete'));
				}
			});
    }
    window.lsgRenderCart = async function(){
      await renderCart();
    };
    window.lsgSlideCartOpen = function() {
      slideCartOpen();
    };
    async function slideCartOpen() {
        if(window.location.pathname != '/cart') {
            await renderCart();
        }
    };
    window.lsgSlideCartClose = function() {
      slideCartClose();
    };
    async function slideCartClose() {
      await renderCart();
    }
    $('[href="/cart"]').on('click', function(e){
        e.preventDefault();
        slideCartOpen();
    });
    $(document).on('click', '[data-slidecart-trigger]', function(){
        slideCartOpen();
    });
    $(document).on('click', '[data-close-slidecart], [slidecart-overlay]', function(){
        slideCartClose();
    });
    if(window.location.href.indexOf('?cart-opened') > -1) {
        slideCartOpen();
    }
    function clearCartDrawer() {
        const ITEM_EL = '.slidecart-item-wrapper';
        const PROD_EL = '.slidecart-product-wrapper';
        const wrapperEl = document.querySelector(ITEM_EL);
        if (wrapperEl) {
            document.querySelectorAll(ITEM_EL).forEach(itemWrapper => itemWrapper.remove());
        } else if (document.querySelector(PROD_EL)){
            document.querySelectorAll(PROD_EL).forEach(prodWrapper => prodWrapper.innerHTML = '');
        }
    }
    const bindSlideCartUIActions = () => {

        function updateItemQuantity(target, key, newQty, currentQty = 1) {
            const bundleChildKeys = $(target).closest('[data-bundle-child-keys]').attr('data-bundle-child-keys');
            const bundleChildQuantities = $(target).closest('[data-bundle-child-keys]').attr('data-bundle-child-quantities');
            const isBundleParent = bundleChildKeys !== '' ? true : false;

            // if this is a bundle parent product
            if (isBundleParent) {
                const childKeysArray = bundleChildKeys.split(',');
                const childQuantitiesArray = bundleChildQuantities.split(',');
            
                let formData = {
                    updates: {}
                };
            
                childKeysArray.forEach((childKey, i) => {
                    const currentChildQty = parseInt(childQuantitiesArray[i]);
                    let newChildQty = (currentChildQty / currentQty) * newQty;
                    if (newChildQty < 0) newChildQty = 0;
            
                    formData['updates'][String(childKey)] = newChildQty;
                });
            
                $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: formData,
                    dataType: 'json',
                    success: function () {
                        renderCart();
                    }
                });
            } else {
                const data = {
                    "id": key,
                    "quantity": newQty
                };
                
                $(`[data-input-key="${key}"]`).attr('value', newQty);
                
                $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: data,
                    dataType: 'json',
                    success: function () {
                        renderCart();
                    }
                });
            }
        }

        // Update item quantity
        // $(document).off().on('click', `[data-qty-button]`, (event) => {
        $(document).on('click', `[data-qty-button]`, (event) => {
            event.preventDefault();
            
            const key = $(event.target).attr('data-key');
            const currentQty = parseInt($(`[data-input-key="${key}"]`).attr('value'));
            let newQty;
        
            if ($(event.target).hasClass('js-plus-button')) {
                newQty = currentQty + 1;
            } else {
                newQty = currentQty - 1;
                if (newQty < 0) newQty = 0;
            }

            updateItemQuantity(event.target, key, newQty, currentQty);
        });

        // Remove item
        $(document).on('click', `.slidecart-wrapper button.removeItem`, function (e) { 
            var key = $(this).attr('data-remove-key');
            updateItemQuantity(e.target, key, 0);
        });

        // Add upsell
        $(document).on('click', '[data-upsell-atc]', (event) => {
            var variantId = $(event.target).attr('data-upsell-atc');
            var data = {
                "id": variantId,
                "quantity": 1,
            };
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                dataType: 'json',
                success: () => {
                    renderCart();
                }
            });
        });

        // Toggle OTP to Subscribe
        $(document).on('click', '[data-cart-toggle-subscribe]', (event) => {
            event.preventDefault();
            updateItemSubscription(event);
        });

        // Change Subscription Plan
        $(document).on('change', '[data-subscribe-select]', (event) => {
            event.preventDefault();
            updateItemSubscription(event);
        });

        $(document).on('click', '[add-upsell]', function(){
           var id = $(this).attr('variant-id');
           var data = {
               "id": id,
               "quantity": 1,
           };
           $.ajax({
               type: 'POST',
               url: '/cart/add.js',
               data: data,
               dataType: 'json',
               success: function() {
                renderCart();
               }
           });
       });
    };
    bindSlideCartUIActions();
    const obscureCartData = (cart) => {
        let obscuredCartData = [];

        cart.items.forEach((item) => {
            const itemPrice = parseFloat(item.line_price / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1").toString();
            const itemSellingPlanAllocation = (item.selling_plan_allocation !== undefined) ? true : false;
            const itemPlanId = (item.selling_plan_allocation !== undefined) ? item.selling_plan_allocation.selling_plan.id : false;
            const itemPlanType = (item.selling_plan_allocation !== undefined) ? item.selling_plan_allocation.selling_plan.name : false;
            const itemBundleID = (item.properties !== null) ? ((item.properties._bundle_id !== undefined) ? item.properties._bundle_id : false) : false;
            let originalPrice = (item.original_line_price && item.original_line_price > (item.discounted_price * item.quantity)) ? parseFloat(item.original_line_price / 100).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1").toString() : "";
            if(item?.properties?._bundle_parent) {
                originalPrice = "";
            }
            const isBundleChild = (item.properties !== null) ? ((item.properties._bundle_id !== undefined && item.properties._bundle_parent === undefined) ? true : false) : false;
            const isBundleParent = (item.properties !== null) ? ((item.properties._bundle_parent === true) ? true : false) : false;
            const isFreeGift = (item.properties !== null) ? ((item.properties._FreeGift !== undefined) ? true : false) : false;
            const itemHandle = item.handle
            const variantTitle = item.variant_title ? item.variant_title : '';
            let imageSrc = item.image;
            if (imageSrc.includes('?')) {
                imageSrc = `${imageSrc}&width=180`;
            } else {
                imageSrc = `${imageSrc}?width=180`;
            }
            let cartDataItem = {
                itemID: item.id,
                itemTitle: item.product_title,
                itemHandle: item.handle,
                itemImage: imageSrc,
                itemPrice: itemPrice,
                itemQuantity: item.quantity,
                itemGrams: item.grams,
                itemUrl: item.url,
                itemKey: item.key,
                itemSellingPlanAllocation: itemSellingPlanAllocation,
                itemPlanId: itemPlanId,
                itemPlanType: itemPlanType,
                itemBundleID: itemBundleID,
                isBundleChild: isBundleChild,
                isBundleParent: isBundleParent,
                bundleChildKeys: '',
                bundleChildQuantities: '',
                bundleItemList: '',
                bundleParentKey: '',
                itemTags: [],
                itemHandle: itemHandle,
                itemOriginalPrice: originalPrice,
                variantTitle,
                isFreeGift
            };

            obscuredCartData.push(cartDataItem);
        });

        let removalIndexes = [];
        obscuredCartData.forEach((mainItem) => {

            if(mainItem.isBundleParent) {

                const mainItemBundleID = mainItem.itemBundleID;
            
                if (mainItemBundleID) {
                    let bundleChildKeys = [];
                    let bundleChildQuantities = [];
                    let bundleItemList = '';
                
                    obscuredCartData.forEach((comparedItem, i) => {
                        const comparedItemBundleID = comparedItem.itemBundleID;
                        const comparedItemPrice = parseFloat(comparedItem.itemPrice);
                        const comparedItemOriginalPrice = parseFloat(comparedItem.itemOriginalPrice);
                        const comparedOriginalPrice = parseFloat(parseFloat(mainItem.itemOriginalPrice) + comparedItemOriginalPrice).toFixed(2);
                        if (comparedItem.isBundleParent === false && comparedItemBundleID === mainItemBundleID) {
                            bundleChildKeys.push(comparedItem.itemKey)
                            bundleChildQuantities.push(comparedItem.itemQuantity)
                            bundleItemList += '<li class="cart-item-bundle-el">' + comparedItem.itemTitle + (comparedItem.itemQuantity > 1 ? ' (' + comparedItem.itemQuantity + ')' : '') + '</li>';
                            mainItem.itemPrice = parseFloat(parseFloat(mainItem.itemPrice) + comparedItemPrice).toFixed(2);
                            mainItem.itemOriginalPrice = !isNaN(comparedOriginalPrice) ? comparedOriginalPrice : '';
                            removalIndexes.push(i);
                        }
                        if (comparedItem.isBundleParent === true && comparedItemBundleID === mainItemBundleID) {
                            bundleChildKeys.push(comparedItem.itemKey)
                            bundleChildQuantities.push(comparedItem.itemQuantity)
                            mainItem.bundleParentKey = comparedItem.itemKey;
                        }
                    });
            
                    mainItem.bundleChildKeys = bundleChildKeys;
                    mainItem.bundleChildQuantities = bundleChildQuantities;
                    mainItem.bundleItemList = (bundleItemList != '' ? '<ul class="cart-item-bundle-items">' + bundleItemList + '</ul>' : '');
                }
            }
        });

        obscuredCartData = obscuredCartData.filter((item, index) => {
            return removalIndexes.indexOf(index) == -1;
        });

        return obscuredCartData;
    };
    const initQuantityElements = () => {
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function (cart) {
                const obscuredCartData = obscureCartData(cart);
                let cartQty = 0;
                obscuredCartData.forEach((item, index) => {
                    if (item.isBundleChild) return;
                    cartQty = cartQty + item.itemQuantity;
                });
                $('[data-cart-slider-total-quantity]').html(`(${cartQty})`);
                $('[data-lsg-cart-count]').html(cartQty);
            }
        });
    };
    const updateQuantityElements = (data) => {
        const obscuredCartData = data;
        let cartQty = 0;
        obscuredCartData.forEach((item, index) => {
            if (item.isBundleChild) return;
            cartQty = cartQty + item.itemQuantity;
        });
        $('[data-cart-slider-total-quantity]').html(`(${cartQty})`);
        $('[data-lsg-cart-count]').html(cartQty);
    }
    const updateItemSubscription = (event) => {
        if(!processingSubscription) {
            processingSubscription = true;
        } else {
            return;
        }

        let key,
            qty,
            plan,
            oldPlan,
            id,
            additionDataArray = { items: [] },
            removalData= {
                updates: {}
            };
    
        if ($(event.target).is('[data-cart-toggle-subscribe]')) {
            key = $(event.target).attr('key');
            id = parseInt($(event.target).attr('product_id'));  
            qty = parseInt($(event.target).attr('qty'));
            plan = parseInt($(event.target).attr('plan_id'));
        }
        if ($(event.target).is('[data-subscribe-select]')) {
            key = $("option:selected", $(event.target)).attr('key');
            id = parseInt($("option:selected", $(event.target)).attr('product_id'));
            qty = parseInt($("option:selected", $(event.target)).attr('qty'));
            plan = parseInt($("option:selected", $(event.target)).attr('value'));
            oldPlan = parseInt($("option:selected", $(event.target)).attr('plan_id'));
        }

        const isOTP = isNaN(parseFloat(plan)); 
    
        if (oldPlan === plan) return 

        // Fetch the current cart to find all relevant items
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                // Find the toggled item in the cart
                const toggledItem = cart.items.find(item => item.key === key);
                if (!toggledItem) {
                    processingSubscription = false;
                    return;
                }
                // If this is a bundle parent or child, get the bundle_id
                const bundleId = toggledItem.properties && toggledItem.properties._bundle_id;
                if (bundleId) {
                    // --- BUNDLE LOGIC (as before) ---
                    const bundleItems = cart.items.filter(item => item.properties && item.properties._bundle_id === bundleId);
                    const parentItem = cart.items.find(item => item.properties && item.properties._bundle_id === bundleId && item.properties._bundle_parent);
                    if (parentItem) {
                        removalData.updates[parentItem.key] = 0;
                    }
                    bundleItems.forEach(item => {
                        removalData.updates[item.key] = 0;
                    });
                    if (parentItem) {
                        let parentAdd = {
                            quantity: parentItem.quantity,
                            id: parentItem.id,
                            properties: {
                                _bundle_id: bundleId,
                                _bundle_parent: true
                            }
                        };
                        if (!isOTP) {
                            parentAdd.selling_plan = plan;
                        }
                        additionDataArray.items.push(parentAdd);
                    }
                    bundleItems.forEach(item => {
                        let childAdd = {
                            quantity: item.quantity,
                            id: item.id,
                            properties: {
                                _bundle_id: bundleId
                            }
                        };
                        if (!isOTP) {
                            childAdd.selling_plan = plan;
                        }
                        additionDataArray.items.push(childAdd);
                    });
                } else {
                    // --- NON-BUNDLE LOGIC ---
                    // Remove all cart items with the same product ID and variant ID
                    cart.items.forEach(item => {
                        if (item.id === toggledItem.id) {
                            removalData.updates[item.key] = 0;
                        }
                    });
                    // Add the new item with the selected plan
                    let newItem = {
                        quantity: toggledItem.quantity,
                        id: toggledItem.id,
                        properties: toggledItem.properties || {}
                    };
                    if (!isOTP) {
                        newItem.selling_plan = plan;
                    }
                    additionDataArray.items.push(newItem);
                }
                // 1. Add new items first
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(additionDataArray)
                }).then(() => {
                    // 2. Remove old items after add is successful
                    $.ajax({
                        type: 'POST',
                        url: '/cart/update.js',
                        data: removalData,
                        dataType: 'json',
                        success: () => {
                            // 3. Wait a short moment, then fetch the updated cart and render
                            setTimeout(() => {
                                fetch('/cart.js')
                                    .then(res => res.json())
                                    .then(cart => {
                                        window.lsgRenderCart();
                                        processingSubscription = false;
                                    });
                            }, 300);
                        }
                    });
                }).catch((error) => {
                    console.error('Error:', error);
                    processingSubscription = false;
                });
            });
    };
    function handleIsInCart(cartHandleArray, itemToCheck){
        if (cartHandleArray.indexOf(itemToCheck) >= 0){
            return true;
        } else {
            return false;
        }
    }
    function renderUpsells(cart) {
        if(document.querySelector('.slidecart-inner-wrapper')){
            document.querySelectorAll('.slidecart-upsell-wrapper .upsell-bar').forEach(item => {
                item.classList.add('upsell-hidden')
            })
            let cartHandleArray = [];
            cart.forEach(cartItem => {
                cartHandleArray.push(cartItem.itemHandle)
            });
            for(let a = 0; a < window.upsellProducts.length; a++){
                let currentItem = window.upsellProducts[a]
                if (window.winter_is_active === 'active' && currentItem.includes('chocolate-peppermint')) {
                    if (!handleIsInCart(cartHandleArray, currentItem)){
                        document.querySelector(`.upsell-bar.upsell-${currentItem}`).classList.remove('upsell-hidden')
                        break;
                    }
                }
                else if (window.winter_is_active === 'active' && currentItem.includes('gingerbread')){
                    if (!handleIsInCart(cartHandleArray, currentItem)){
                        document.querySelector(`.upsell-bar.upsell-${currentItem}`).classList.remove('upsell-hidden')
                        break;
                    }
                }
                else if (window.winter_is_active === 'active' && currentItem.includes('peppermint-mocha')){
                    if (!handleIsInCart(cartHandleArray, currentItem)){
                        document.querySelector(`.upsell-bar.upsell-${currentItem}`).classList.remove('upsell-hidden')
                        break;
                    }
                }
                else if (currentItem === ('pumpkin-spice-12-bars') && window.pumpkinIsActive === "active"){
                    if (!handleIsInCart(cartHandleArray, currentItem)){
                        if (document.querySelector(`.upsell-bar.upsell-${currentItem}`)){
                            document.querySelector(`.upsell-bar.upsell-${currentItem}`).classList.remove('upsell-hidden')
                            break;
                        }
                    }
                }
                else if (currentItem === ('pumpkin-spice-16-sticks') && window.pumpkinIsActive === "active"){
                    if (!handleIsInCart(cartHandleArray, currentItem)){
                        if (document.querySelector(`.upsell-bar.upsell-${currentItem}`)){
                            document.querySelector(`.upsell-bar.upsell-${currentItem}`).classList.remove('upsell-hidden')
                            break;
                        }
                    }
                }
                else if (currentItem.includes('iqjoe-variety-pack')){
                    if (!handleIsInCart(cartHandleArray, currentItem)){
                        if (document.querySelector(`.upsell-bar.upsell-${currentItem}`)){
                            document.querySelector(`.upsell-bar.upsell-${currentItem}`).classList.remove('upsell-hidden')
                            break;
                        }
                    }
                } else if (currentItem.includes('tropical-pack')){
                    if (!handleIsInCart(cartHandleArray, currentItem) && handleIsInCart(cartHandleArray, 'iqjoe-variety-pack')){
                        showUpsell(`.upsell-bar.upsell-${currentItem}`)
                        break;
                    }
                } else if (currentItem.includes('toasted-coconut-chip')){
                    if (!handleIsInCart(cartHandleArray, currentItem) && handleIsInCart(cartHandleArray, 'iqjoe-variety-pack') && handleIsInCart(cartHandleArray, 'tropical-pack')){
                        if (document.querySelector(`.upsell-bar.upsell-${currentItem}`)){
                            document.querySelector(`.upsell-bar.upsell-${currentItem}`).classList.remove('upsell-hidden')
                            break;
                        }
                    }                   
                } else if (!currentItem.includes('toasted-coconut-chip') || !currentItem.includes('tropical-pack') || !currentItem.includes('iqjoe-variety-pack')){
                    if (!handleIsInCart(cartHandleArray, currentItem)){
                        if (document.querySelector(`.upsell-bar.upsell-${currentItem}`)){
                            document.querySelector(`.upsell-bar.upsell-${currentItem}`).classList.remove('upsell-hidden')
                            break;
                        }
                    }       
                } else {
                    currentItem = window.upsellProducts[window.upsellProducts.length -1]
                    if (!handleIsInCart(cartHandleArray, currentItem)){
                        if (document.querySelector(`.upsell-bar.upsell-${currentItem}`)){
                            document.querySelector(`.upsell-bar.upsell-${currentItem}`).classList.remove('upsell-hidden')
                            break;
                        }
                    }
                }
            }
        }
    }

    if(window.location.pathname == '/cart') {
        renderCart();
    }
});